import React, { useState, useEffect, useRef } from 'react';
import { Button, Popover } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { useHistory } from 'react-router-dom';


import './studentModuleDashboard.css'
import { studentCheckLogin } from '../newMain/studentMain';
import ModuleListSort from './moduleListSort';
import searchImg from '../../public/img/newMain/Search.png'
import sortImg from '../../public/img/newMain/Sort.png'
import resetImg from '../../public/img/newMain/Reset.png'

const StudentModuleDashboard = (props) => {
    const history = useHistory();
    const [moduleList, setModuleList] = useState([]);
    const searchModel = useRef({});
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [isReset, setIsReset] = useState(false);
    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        searchModuleList();
    }, []);

    const searchModuleList = () => {
        let model = {...searchModel.current};
        model.studentId = Config.studentInfo?.studentId;
        Base.callBackApi("studentModule/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let list = data?.object ?? [];
                setModuleList(list);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const jump = (path, studentModuleId) => {
        localStorage.setItem(Config.tokenPrefix + 'studentModuleId', studentModuleId);
        history.push(path);
    }

    const searchChange = (key, value) => {
        searchModel.current = { ...searchModel.current, ...{ [key]: value } };
        searchModuleList();
    }

    const reset = () => {
        searchModel.current = {};
        setModuleList([]);
        setIsReset(true)
        searchModuleList();
    }

    const handleOpenChange = (newOpen) => {
        setPopoverVisible(newOpen);
    };

    const handleOpenChangeSort = (newOpen, flag, model) => {
        setIsReset(false)
        setPopoverVisible(newOpen);
        if(flag) {
            searchModel.current = { ...searchModel.current, ...model }
            searchModuleList();
        }
    };

    return (
        <div id="container" className='websiteTemplate studentModuleDashboard'>
            <div className='homeTitle'>Module List</div>
            <div className='websiteSysSearchRow'>
                <div className='websiteSysSearchBar'>
                    <input style={{ paddingLeft: '11px' }} placeholder="Search by Module" value={searchModel.current.moduleName || ''}
                        onKeyDown={(e) => e.key === "Enter" ? searchModuleList() : null}
                        onChange={(e) => searchChange('moduleName', e.target.value)} />
                    <img src={searchImg} onClick={() => searchModuleList()} />
                </div>
                <Popover placement="topRight" trigger="click" open={popoverVisible}
                    onOpenChange={handleOpenChange} content={
                        <ModuleListSort isReset={isReset} onOpenChange={handleOpenChangeSort} />
                    }
                    getPopupContainer={() => document.getElementById('sortButton')}
                >
                    <div className='websiteSysButton sortButton' id='sortButton'><img src={sortImg} />Sort</div>
                </Popover>
                <div className='websiteSysButton sortButton' onClick={reset}><img src={resetImg} />Reset</div>
            </div>
            {moduleList?.map((item, index) =>
                <div className='moduleBox' key={item?.studentModuleId}>
                    <div className='moduleBoxLeft'>
                        <div className='cardSubTitle'>{item?.moduleCode}</div>
                        <div className='cardSubTitle'>{item?.moduleName}</div>
                        <div className='flexBox'>
                            <div className='label'>Cohort Year</div>
                            <div className='value'>{item?.cohortYear}</div>
                        </div>
                    </div>
                    <div className='moduleBoxCenter'>
                        <div>
                            <div className='countTitleBox'>
                                <div className='cardSubTitle'>WIL Hours</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>Total Curriculum Hours</div>
                                <div className='value '>{item?.curriculumHours}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>Other Learning Activities Hours</div>
                                <div className='value '>{item?.otherLearningTrainingHours}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>WIL Hours Exempted</div>
                                <div className='value '>{item?.exemptedHours}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>WIL Hours Needed</div>
                                <div className='value '>{item?.neededWilHours}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>WIL Hours Completed</div>
                                <div className='value '>{item?.completedWilHours} ({item?.neededWilHours > 0 ? Base.parseToPercent(item?.completedWilHours / item?.neededWilHours) : 100}%)</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'># of WPA in progress</div>
                                <div className='value '>{item?.inProgressWpaCount}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'># of WPA status Sent to IP that is over 14 days</div>
                                <div className='value '>{item?.sentToIsCount}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'># of WPA Completed</div>
                                <div className='value '>{item?.completedWpaCount}</div>
                            </div>
                        </div>
                        <div>
                            <div className='countTitleBox'>
                                <div className='cardSubTitle'>Assignments</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'># of Assignments submitted vs. target</div>
                                <div className='value '>{item?.studentModuleAssignModelList ? item?.studentModuleAssignModelList?.filter(item => item.status == 'SUBMITTED')?.length + '/' + item?.studentModuleAssignModelList?.length : '0/0'}</div>
                            </div>
                            <div className='countTitleBox'>
                                <div className='cardSubTitle'>Marks</div>
                            </div>
                            {item?.studentModuleAssignModelList?.map(item =>
                                <div className='flexBox ' key={item?.studentModuleAssignId}>
                                    <div className='label'>{item?.assignName} mark</div>
                                    <div className='value '>{item?.assignMarks == 0 ? '0/100' : (item?.assignMarks ? Base.parseToFixed(item?.assignMarks, 2) + '/100' : 'Incomplete')}</div>
                                </div>
                            )}
                            <div className='flexBox '>
                                <div className='label'>Total WPA mark</div>
                                <div className='value '>{item?.wpaMarks == 0 ? '0/100' : (item?.wpaMarks ? Base.parseToFixed(item?.wpaMarks, 2) + '/100'  : 'N/A')}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>Total Module Mark and grade</div>
                                <div className='value '>{item?.totalModuleMark == 0 ? '0/100' : (item?.totalModuleMark ? Base.parseToFixed(item?.totalModuleMark, 2) + '/100 (' + Base.calcGrade(item?.totalModuleMark) + ')' : 'N/A')} </div>
                            </div>
                        </div>
                    </div>
                    <div className='moduleBoxRight'>
                        <Button className="websiteSysButton detailButton" icon={<EyeOutlined style={{ fontSize: "18px" }} />} onClick={() => jump("/student/studentModule", item.studentModuleId)}>Detail</Button>
                    </div>
                </div>
            )}
        </div>
    )

}

export default StudentModuleDashboard;